<i18n src="./resources/locales.json"></i18n>
<template>
  <div :id="`${additionalOption.key}-additional-option`">
    <v-checkbox
      :id="`${additionalOption.key}-checkbox`"
      class="mb-3"
      color="primary"
      hide-details
      :disabled="disabled"
      :label="$t(additionalOption.checkboxLabel)"
      :input-value="additionalOption.fieldInformation.display"
      @click="onCheckboxClick"
    ></v-checkbox>
    <v-text-field
      :id="`${additionalOption.key}-text-field`"
      outlined
      dense
      hide-details
      :disabled="disabled"
      :label="$t(additionalOption.textFieldLabel)"
      :value="additionalOption.fieldInformation.label"
      @input="onTextFieldChange"
    ></v-text-field>
  </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'EcsAdditionalOption',
  props: {
    additionalOption: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onCheckboxClick() {
      this.$emit(
        'checkboxClick',
        this.additionalOption.key,
        this.additionalOption.fieldInformation.label,
        !this.additionalOption.fieldInformation.display
      );
    },
    onTextFieldChange: debounce(function(value) {
      this.$emit('textFieldChange', this.additionalOption.key, value, this.additionalOption.fieldInformation.display);
    }, 500)
  }
};
</script>

<style></style>
